
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoi4LmA4Lij4Li14Lii4LiB4LiU4Li54LiX4Lix4LmJ4LiH4Lir4Lih4LiUIn0%3D!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoi4LmA4Lij4Li14Lii4LiB4LiU4Li54LiX4Lix4LmJ4LiH4Lir4Lih4LiUIn0%3D!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiVGVsdXN1cmkgc2VtdWEifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiVGVsdXN1cmkgc2VtdWEifQ%3D%3D!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoi4LmA4Lij4Li14Lii4LiB4LiU4Li54LiX4Lix4LmJ4LiH4Lir4Lih4LiUIn0%3D!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoi4LmA4Lij4Li14Lii4LiB4LiU4Li54LiX4Lix4LmJ4LiH4Lir4Lih4LiUIn0%3D!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiVGVsdXN1cmkgc2VtdWEifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiVGVsdXN1cmkgc2VtdWEifQ%3D%3D!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiQnJvd3NlIGFsbCJ9!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiW%2BG6nsWZw7bDtsO2xbXFoeG6veG6veG6vSDEg8SDxIPGmsaaXSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJCcm93c2UgYWxsIjoiW%2BG6nsWZw7bDtsO2xbXFoeG6veG6veG6vSDEg8SDxIPGmsaaXSJ9!"
        )
      )
      });
  
      export { translations as default };
    